import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center mt-14 w-full 2xl:w-[50%] mx-auto" }
const _hoisted_2 = { class: "flex flex-col justify-center items-center gap-x-9 w-full" }
const _hoisted_3 = { class: "flex flex-col gap-5 overflow-auto pr-8 w-[100%]" }
const _hoisted_4 = { class: "text-gray-900 font-medium text-lg" }
const _hoisted_5 = { class: "flex flex-col gap-y-8" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { class: "flex gap-3" }
const _hoisted_8 = { class: "font-semibold text-gray-700 text-base" }
const _hoisted_9 = { class: "font-normal text-dark-grey text-sm" }
const _hoisted_10 = { class: "flex flex-col gap-0 px-[10px] rounded-lg w-[25rem]" }
const _hoisted_11 = { class: "text-gray-700 text-sm font-semibold pb-3" }
const _hoisted_12 = { class: "flex gap-2" }
const _hoisted_13 = { class: "flex flex-col flex-wrap gap-3 font-medium mt-1 text-sm text-white" }
const _hoisted_14 = {
  key: 0,
  class: "rounded-lg bg-blue-600 border border-blue-600 px-3 py-2 text-sm font-semibold shadow-box cursor-default"
}
const _hoisted_15 = {
  key: 1,
  class: "rounded-lg bg-blue-600 border border-blue-600 px-4 py-2 text-sm font-semibold shadow-box cursor-default"
}
const _hoisted_16 = { class: "flex gap-2" }
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = {
  key: 0,
  class: "flex justify-between items-center w-full pr-8 mt-6"
}
const _hoisted_19 = { class: "text-gray-600 font-semibold text-sm" }

import { NewClassGroup, NewClassTeacher } from '@/interfaces/school-structure.interface';
import { onMounted, ref } from 'vue';
import { PencilIcon } from "@heroicons/vue/24/outline";
import { useSubjectStore } from '@/stores/subjectStore';

type SubjectStoreType = ReturnType<typeof useSubjectStore>;
  

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewTeacherAssignedToClasses',
  props: {
    step: {},
    teachersArray: {},
    classGroupsArray: {},
    subjectStore: {}
  },
  emits: ["handleBack", "handleReset", "showSendModal"],
  setup(__props: any, { emit }) {

const props = __props;





const classGroups = ref<NewClassGroup[]>([]);
const teachers = ref<NewClassTeacher[]>([]);

const teacherClasses = (teacher: any, subject: string) => {
  // Find the subject ID in the store based on the subject name
  const subjectId = props.subjectStore.subjects.find(
    (s : any ) => s.name.toLowerCase() === subject.toLowerCase()
  )?.id;

  return teacher.classes
    .map((classId: any) => {
      const foundClass = classGroups.value.find(
        (c: any) => c.tempId === classId
      );
      if (foundClass && foundClass.subject === subjectId) {
        return { className: foundClass.name };
      }
      return null;
    })
    .filter((classObj: any) => classObj !== null);
};

const teacherSubjects = (teacher: any) => {
  let subjects = {
    maths: false,
    english: false,
  };

  // Find the subject IDs in the store for Maths and English
  const mathsId = props.subjectStore.subjects.find((s: any) => s.name === "Maths")?.id;
  const englishId = props.subjectStore.subjects.find((s: any) => s.name === "English")?.id;

  // Loop through each class assigned to the teacher
  teacher.classes.forEach((classId: any) => {
    const foundClass = classGroups.value.find((c: any) => c.tempId === classId);

    if (foundClass) {
      if (foundClass.subject === mathsId) {
        subjects.maths = true;
      }
      if (foundClass.subject === englishId) {
        subjects.english = true;
      }
    }
  });

  return subjects;
};

onMounted(() => {
  teachers.value = props.teachersArray;
  classGroups.value = props.classGroupsArray;
});


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "flex gap-6 items-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('handleBack')))
        }, [
          _createVNode(_component_rl_icon, {
            icon: 'rl-back-arrow',
            title: 'rl back arrow',
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.review_teachers")), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "py-5 px-4 bg-white rounded-[20px] shadow-sm border border-blue-600 mt-3",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-profile',
                    title: 'rl profile',
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_8, _toDisplayString(teacher.firstName) + " " + _toDisplayString(teacher.lastName), 1),
                    _createElementVNode("h5", _hoisted_9, _toDisplayString(teacher.email), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.classes")), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (teacherSubjects(teacher).maths)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_14, " M "))
                      : _createCommentVNode("", true),
                    (teacherSubjects(teacher).english)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_15, " E "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass('flex flex-col  font-medium text-sm ' +
                        (teacherClasses(teacher, 'Maths').length > 0 &&
                        teacherClasses(teacher, 'English').length > 0
                        ? 'gap-3'
                        : 'gap-[0.20rem]')
                        )
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherClasses(
                            teacher,
                            'Maths'
                            ), (className, index) => {
                          return (_openBlock(), _createElementBlock("button", {
                            class: _normalizeClass('rounded-lg cursor-default px-4 py-2 text-gray-700 border border-[D0D5DD] mt-[3px] shadow-box font-semibold ' +
                            (teacherClasses(teacher, 'Maths').length > 0 &&
                            teacherClasses(teacher, 'English').length > 0
                            ? 'mt-[3px]'
                            : 'mt-0')
                            ),
                            key: index
                          }, _toDisplayString(className.className.toUpperCase()), 3))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherClasses(
                            teacher,
                            'English'
                            ), (className, index) => {
                          return (_openBlock(), _createElementBlock("button", {
                            class: "rounded-lg cursor-default border border-gray-300 text-gray-700 px-4 py-2 shadow-box font-semibold",
                            key: index
                          }, _toDisplayString(className.className.toUpperCase()), 1))
                        }), 128))
                      ])
                    ], 2)
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      (_ctx.step >= 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "flex gap-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('handleReset')))
            }, [
              _createVNode(_unref(PencilIcon), { class: "h-5 w-5 text-gray-600" }),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.edit")), 1)
            ]),
            _createElementVNode("button", {
              class: "px-4 p-2 rounded-lg flex items-center justify-center text-white bg-blue-600",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('showSendModal')))
            }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.btn_done")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})